import { AdPlatform } from '@/shared/types/enums';

/** Platform path segment used by the auth endpoints (X is served under `x`). */
export function platformToPathSegment(platform: string): string {
  if (platform === AdPlatform.TWITTER) return 'x';
  return platform.toLowerCase();
}
